/**
 * Model "class" for User - defines useful field metadata for building and validating forms
 * (only used for password reset and login)
 */

import {required, minLength, sameAs} from 'vuelidate/lib/validators'

// custom validator for password
const validPassword = (value) => {
    return /[a-z]/.test(value) &&
        /[A-Z]/.test(value) &&
        /\d/.test(value) &&
        /[~!@#$%^&*()<>=_+-]/.test(value)
}

// custom validator to allow repeat-password field to be empty if password field is empty
const sameAsPassword = (value, vm) => {
    return !vm.password || value == vm.password
}

export default {
    fields: {
        email: {
            label: 'FIELD_USER_EMAIL',
            type: 'email',
            validations: {required}
        },
        password: {
            label: 'FIELD_USER_PASSWORD',
            type: 'password',
            autocomplete: 'new-password',
            validations: {
                required,
                minLength: minLength(8),
                validPassword,
            },
            invalidFeedback: {
                required: 'MESSAGE_FIELD_REQUIRED',
                minLength: 'MESSAGE_PASSWORD_TOO_SHORT',
                validPassword: 'MESSAGE_PASSWORD_INVALID',
            }
        },
        password_repeat: {
            label: 'FIELD_USER_PASSWORD_REPEAT',
            type: 'password',
            autocomplete: 'new-password-confirm',
            validations: {
                sameAs: sameAs('password')
            },
            invalidFeedback: {
                sameAs: 'MESSAGE_PASSWORDS_MUST_MATCH'
            }
        },
    }
}
